import React from "react";

import { Grid } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import ExpandMoreOutlinedIcon from "@material-ui/icons/ExpandMoreOutlined";
import PropTypes from "prop-types";
import DataTable from "react-data-table-component";

import "./styles.scss";

const DefaultDataTable = ({ columns, data, noDataMessage, ...props }) => {
  const _className = props.className ? ` ${props.className}` : "";
  return (
    <DataTable
      className={`DefaultDataTable${_className}`}
      columns={columns}
      data={data}
      {...props}
      sortIcon={<ExpandMoreOutlinedIcon fontSize="large" />}
      noDataComponent={
        noDataMessage && (
          <Grid className="noDataGrid">
            <Typography variant="h4" align="center" className="noData">
              {noDataMessage}
            </Typography>
          </Grid>
        )
      }
    />
  );
};

DefaultDataTable.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
};

export default DefaultDataTable;
